import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import "../../styles/components/TransactionTypes.scss";
import TransactionSummaryRow from "../TransactionSummaryRow";

const TransactionTypes = (props) => {
  const data = props.data;
  const data5 = props.data5;
  console.log("data5 below");
  console.log(data5);
  // Object.entries(data5).map(([key, value]) => (
  //   console.log("key : ",key," value=",value.value)
  // ))
  // console.log(data);

  const [activeButton, setActiveButton] = useState("all");

  const handleButtonClick = (buttonId) => {
    setActiveButton(buttonId);
  };

  // console.log(props.data5)
  return (
    <>
      <div
        style={{ margin: "8px", "font-weight": "600", "font-size": "1.1rem" }}
      >
        <h5
          style={{
            "border-top": "2px dashed #7c7c80",
            margin: "13px 0px",
            "padding-top": "1.5%",
            "font-weight": "700",
            "font-size": "17px",
          }}
        >
          Transaction Types
        </h5>
      </div>
      <div style={{ display: "flex", "margin-top": "-1%" }}>
        {Object.entries(data).map(([key, value]) => (
          <div className="buttons">
            <Button
              // onMouseMove ={() => handleButtonClick("selected")}
              className={`transactionButton`}
              // variant="outline-secondary"
            >
              {value.category} - {value.count}
            </Button>
          </div>
        ))}
      </div>

      {/* color - 7c7c80,  */}
      <div>
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            letterSpacing: "0.32px",
            color: "#7c7c80",
            fontStyle: "normal",
            margin: "8px",
          }}
        >
          Loan details
        </div>
        <div className="typescomponents">
          <TransactionSummaryRow data={data5} />
        </div>
        <div>
          <h1 style={{ color: "white" }}>.</h1>
        </div>
      </div>
    </>
  );
};

export default TransactionTypes;
